import {
  BrowserRouter,
  Routes as RouteWrapper,
  Route,
  Navigate,
} from "react-router-dom";
import { connect } from "react-redux";
import { CheckPermission } from "scripts/helpers";
import Routes from "scripts/routes";

const App = ({ permissions = [] }) => {
  return (
    <BrowserRouter basename="/">
      <RouteWrapper>
        {Routes.map(({ component: Component, name, path, routes }) => (
          <Route key={name} path={path} element={<Component routes={routes} />}>
            {routes?.map(
              ({
                authority,
                component: Component,
                name,
                path,
                redirect,
                routes,
              }) =>
                redirect ? (
                  <Route
                    key={name}
                    path={path}
                    element={<Navigate to={redirect} replace />}
                  />
                ) : routes ? (
                  routes.map(
                    ({
                      authority,
                      component: Component,
                      name: routeName,
                      path,
                    }) =>
                      !authority || CheckPermission(permissions, authority) ? (
                        <Route
                          key={routeName}
                          path={path}
                          element={
                            <Component
                              routeName={routeName}
                              parentName={name}
                            />
                          }
                        />
                      ) : (
                        <Route
                          key={routeName}
                          path={path}
                          element={<Navigate to="/403" replace />}
                        />
                      )
                  )
                ) : !authority || CheckPermission(permissions, authority) ? (
                  <Route
                    key={name}
                    path={path}
                    element={<Component routeName={name} parentName={name} />}
                  />
                ) : (
                  <Route
                    key={name}
                    path={path}
                    element={<Navigate to="/403" replace />}
                  />
                )
            )}
          </Route>
        ))}
        <Route path="*" element={<Navigate to="/404" replace />} />
      </RouteWrapper>
    </BrowserRouter>
  );
};

export default connect((state) => {
  return {
    permissions: state.user.permissions,
  };
})(App);
